import { useQuery } from "@tanstack/react-query";
import { getApiErrorStatus } from "@/lib/apiErrors";
import { chatsApi } from "@/lib/humhub-api/chats";
import { chatKeys } from "@/lib/queryKeys/chatKeys";

export const useChatRoomInfo = (id: string | number) => {
  // React Queryでデータ取得
  const {
    data: chatRoom,
    isLoading: loading,
    error: queryError,
    refetch,
  } = useQuery({
    queryKey: chatKeys.room(id),
    queryFn: () => chatsApi.getChatRoom(id),
    enabled: !!id, // idがある場合のみクエリ実行
    staleTime: 5 * 60 * 1000, // チャットルーム情報は5分間キャッシュ
  });

  return {
    data: chatRoom || null,
    isLoading: loading,
    error: queryError ?? null,
    errorStatus: getApiErrorStatus(queryError),
    refetch: () => refetch(),
  };
};
